export default function GameBasedLearning() {
  return (
    <iframe
      src="/teaching/index.html"
      className="w-full h-screen border-none"
      title="Game-based Learning"
    />
  );
}
